import { Stack } from "@mui/material";
import CategoryDto from "../../../models/CategoryDto";
import RestaurantBanner from "../../RestaurantBanner";
import CategoryListCardItem from "./CategoryListCardItem";

interface MenuCardProps {
  categories: CategoryDto[];
}

export default function MenuCard({ categories }: MenuCardProps) {
  return (
    <Stack spacing={{ xs: 1.5, sm: 2, md: 3 }}
      direction="column"
      justifyContent="space-around">
      <RestaurantBanner />
      {
        categories.map((category: CategoryDto) => (
          <CategoryListCardItem key={"category_" + category.id} category={category} />
        ))
      }
    </Stack>
  );
}